<template>
    <UiMapLeafletApiProductMap
        v-editable="blok"
        class="ui-product-map"
        :blok="blok"
        :products="processedProducts"
        :airport="airport"
        :sorting-functions="sortingFunctions"
    />
</template>

<script setup lang="ts">
import type { IAirportEntity, IAirportProducts } from '@nuxt-monorepo/ui/types';
import type { IApiProductMap } from '@nuxt-monorepo/ui/types/components/Map/ApiProductMap';

defineProps<{ blok: IApiProductMap }>();

const products = inject<Ref<IAirportProducts>>('apiProducts');
const airport = inject<Ref<IAirportEntity>>('airportData');
const processedProducts: IAirportProducts = JSON.parse(JSON.stringify(products));
processedProducts.hotels?.forEach((item) => {
    if (item.provider === 'PSF') {
        item.info.url = `/psf/${item.slug ?? item.info.slug}`;
    }
});

// Sorting by distance is needed to add to HTML 10 closest to airport products
const sortingFunctions = {
    hotels: (a: IAirportProducts['hotels'][0], b: IAirportProducts['hotels'][0]) =>
        a.overview?.distance_to_airport - b.overview.distance_to_airport,
    parking: (a: IAirportProducts['parking'][0], b: IAirportProducts['parking'][0]) => +a.distance - +b.distance,
};
</script>

<style lang="postcss" scoped>
.ui-product-map {
    :deep {
        .close-icon {
            /* because of specific font on APR additional icon margin required for aligment */
            @apply mt-1;
        }
        .map-btn {
            &.map-active {
                button {
                    @apply text-base bg-brand-secondary-500 w-full text-brand-primary-500 rounded-lg border-none font-normal uppercase;
                    @apply hover:bg-brand-secodnary-light-30 active:outline-4 active:outline active:outline-brand-secondary-500 hover:text-brand-primary-500;
                }
            }
            button {
                @apply h-12 text-base bg-brand-secondary-500 w-full text-brand-primary-500 rounded-lg transition-colors duration-300 font-normal uppercase;
                @apply hover:bg-brand-secodnary-light-30 active:outline-4 active:outline active:outline-brand-secondary-500;

                .iconify {
                    @apply w-4 h-4;
                }

                .close-icon {
                    @apply h-8 w-8;
                }
            }
        }
        .map-product-card {
            .link-button {
                @apply text-brand-primary-500 transition-colors duration-300 font-normal text-base uppercase;
                @apply bg-brand-secondary-500 rounded-lg hover:bg-brand-secodnary-light-30 active:outline active:outline-4 active:outline-brand-secondary-500;
            }
        }
    }
}
</style>
